import { FEATURES } from 'utils/features'

const FONTS_API_DOMAIN = 'fonts.googleapis.cn'
const FONTS_STATIC_DOMAIN = 'fonts.gstatic.cn'

export const initCnEnvironment = () => {
  if (!FEATURES.useCnFontMirrors || typeof document === 'undefined') return

  const head = document.head || document.getElementsByTagName('head')[0]

  const selectors = ['link[href*="fonts.googleapis.com"]', 'link[href*="fonts.gstatic.com"]']
  selectors.forEach(sel => {
    document.querySelectorAll(sel).forEach(el => el.parentNode?.removeChild(el))
  })

  const ensureLink = (rel: string, href: string, attrs?: Record<string, string>) => {
    if (document.querySelector(`link[rel="${rel}"][href="${href}"]`)) return
    const link = document.createElement('link')
    link.rel = rel
    link.href = href
    if (attrs) Object.entries(attrs).forEach(([k, v]) => link.setAttribute(k, v))
    head.appendChild(link)
  }

  ensureLink('preconnect', `https://${FONTS_API_DOMAIN}`)
  ensureLink('preconnect', `https://${FONTS_STATIC_DOMAIN}`, { crossorigin: '' })

  ensureLink('stylesheet', `https://${FONTS_API_DOMAIN}/css?family=Roboto:300,400,500,700&display=swap`)
  ensureLink('stylesheet', `https://${FONTS_API_DOMAIN}/css2?family=Open+Sans:wght@300;400;700&display=swap`)
}
